var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTripLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_678_3624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.75 0.5C9.51315 0.502967 7.36876 1.39287 5.78706 2.97456C4.20537 4.55626 3.31547 6.70065 3.3125 8.9375C3.3125 14.9949 11.1734 22.5816 11.5074 22.9016C11.5724 22.9647 11.6594 23 11.75 23C11.8406 23 11.9276 22.9647 11.9926 22.9016C12.3266 22.5816 20.1875 14.9949 20.1875 8.9375C20.1845 6.70065 19.2946 4.55626 17.7129 2.97456C16.1312 1.39287 13.9869 0.502967 11.75 0.5ZM11.75 12.8047C10.9851 12.8047 10.2375 12.5779 9.60151 12.1529C8.96555 11.728 8.46988 11.124 8.17719 10.4174C7.88449 9.71077 7.8079 8.93321 7.95712 8.18305C8.10634 7.43289 8.47465 6.74382 9.01549 6.20299C9.55632 5.66215 10.2454 5.29384 10.9955 5.14462C11.7457 4.9954 12.5233 5.07199 13.2299 5.36468C13.9365 5.65738 14.5405 6.15305 14.9654 6.78901C15.3904 7.42496 15.6172 8.17264 15.6172 8.9375C15.6166 9.96295 15.2089 10.9462 14.4838 11.6713C13.7587 12.3964 12.7755 12.8041 11.75 12.8047Z",
    fill: "#0098C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_678_3624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 22.5,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripLocation);
export default __webpack_public_path__ + "static/media/tripLocation.762092ac6cdbe2da831df89afbce0491.svg";
export { ForwardRef as ReactComponent };